module.exports = __webpack_public_path__ + "static/appstore-7abe3a7b8042982f7b7c50f2cda6572d.svg";